(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
document.addEventListener('DOMContentLoaded', function() {
  // Funcție care verifică dacă un element are dropdown
  const hasDropdown = (element) => {
    return element.querySelector('.menu-list__submenu') !== null;
  };

  // Verificăm doar pe desktop (>= 750px)
  const setupDropdownHover = () => {
    if (window.innerWidth < 750) return;
    
    const header = document.querySelector('header-component');
    if (!header) return;

    // Găsim toate elementele <li> din meniu
    const menuItems = document.querySelectorAll('.menu-list__list-item');
    
    menuItems.forEach(item => {
      // Resetăm evenimentele pentru a evita duplicate
      item.removeEventListener('mouseenter', addHeaderClass);
      item.removeEventListener('mouseleave', removeHeaderClass);
      
      // Dacă elementul are dropdown
      if (hasDropdown(item)) {
        item.addEventListener('mouseenter', addHeaderClass);
        item.addEventListener('mouseleave', removeHeaderClass);
      }
    });
  };

  // Funcții helper
  const addHeaderClass = (e) => {
    const header = document.querySelector('header-component');
    header?.classList.add('has-dropdown-open');
  };

  const removeHeaderClass = (e) => {
    const header = document.querySelector('header-component');
    header?.classList.remove('has-dropdown-open');
  };

  // Inițializare
  setupDropdownHover();

  // Re-run la resize (pentru switching desktop/mobile)
  window.addEventListener('resize', setupDropdownHover);

  // Observă modificări în DOM (pentru meniuri dinamice)
  new MutationObserver(setupDropdownHover)
    .observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-all"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Setări pentru înălțimea viewport-ului pe mobile
  function setVH() {
    if (window.innerWidth <= 768) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
  
  setVH();
  window.addEventListener('resize', setVH);

  // Navigare cu săgeți (doar pentru desktop)
  const container = document.getElementById("lookbook-horizontal-scroll");
  const prevBtn = document.querySelector(".lookbook-arrow.prev");
  const nextBtn = document.querySelector(".lookbook-arrow.next");

  // Verifică dacă elementele există (pentru a evita erori pe mobile)
  if (container && prevBtn && nextBtn) {
    const scrollAmount = 300;

    prevBtn.addEventListener("click", () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener("click", () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("lookbook-horizontal-scroll");
    const prevBtn = document.querySelector(".lookbook-arrow.prev");
    const nextBtn = document.querySelector(".lookbook-arrow.next");

    // Verifică dacă elementele există (pentru a evita erori pe mobile)
    if (container && prevBtn && nextBtn) {
      const scrollAmount = 300;

      // Scroll lookbook with arrows
      prevBtn.addEventListener("click", () => {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener("click", () => {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
